import { Badge, ButtonProps } from '@mui/material';
import { Tooltip } from '@dtsl/react';
import ChatIcon from '../../../icons/ChatIcon';
import useChatContext from '../../../hooks/useChatContext/useChatContext';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import withStyles from '@mui/styles/withStyles';
import { useTranslation } from 'react-i18next';
import { ComponentType } from 'react';

const UnreadMessagesCountBadge = withStyles({
  badge: {
    background: '#DDE5E9',
    color: 'var(--sib-color_content-primary)',
  },
})(Badge);

export default function ToggleChatButton(props: { iconFill?: string; CustomToggleButton: ComponentType<ButtonProps> }) {
  const { isChatWindowOpen, setIsChatWindowOpen, unreadMessagesCount } = useChatContext();
  const { setIsBackgroundSelectionOpen } = useVideoContext();
  const { t } = useTranslation();
  const { CustomToggleButton } = props;

  const toggleChatWindow = () => {
    setIsChatWindowOpen(!isChatWindowOpen);
    setIsBackgroundSelectionOpen(false);
  };

  return (
    <Tooltip text={t('ROOM.CHAT_TOOLTIP')} placement="top">
      <CustomToggleButton
        id="video-calls-toggle-chat"
        onClick={toggleChatWindow}
        startIcon={
          <UnreadMessagesCountBadge overlap="rectangular" badgeContent={unreadMessagesCount}>
            <ChatIcon fill={props.iconFill} />
          </UnreadMessagesCountBadge>
        }
      >
        {t('ROOM.CHAT')}
      </CustomToggleButton>
    </Tooltip>
  );
}
